export default {"src":"/login-app/[GIT_HASH]/_next/static/media/tag.1b19936f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};